(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("moment"), require("@alifd/next"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "moment", "@alifd/next"], factory);
	else if(typeof exports === 'object')
		exports["BizComps"] = factory(require("react"), require("react-dom"), require("moment"), require("@alifd/next"));
	else
		root["BizComps"] = factory(root["React"], root["ReactDOM"], root["moment"], root["Next"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__24__, __WEBPACK_EXTERNAL_MODULE__27__, __WEBPACK_EXTERNAL_MODULE__54__) {
return 